import { render, staticRenderFns } from "./material-pane.vue?vue&type=template&id=156773b7&scoped=true"
import script from "./material-pane.vue?vue&type=script&lang=ts"
export * from "./material-pane.vue?vue&type=script&lang=ts"
import style0 from "./material-pane.vue?vue&type=style&index=0&id=156773b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156773b7",
  null
  
)

export default component.exports